import createVueApp from '@/common/create_app'

Styxie.Initializers.MlapSettingsGoogleAds = {
  show: async(props) => {
    const { default: GoogleAdsSettings } = await import('@/vue_widgets/mlap/settings/google_ads/index.vue')
    createVueApp(GoogleAdsSettings, { props })
  }
}
